import ServicePrice from 'domains/models/service_price';
import TaxRate from 'domains/models/tax_rate';
import {
  TaxInclusive,
  TaxInclusiveText,
} from 'domains/models/tax_rate/tax_inclusive';
import { z } from 'zod';
import { TaxInclusiveTextEnum } from '../tax_rate/enum';
import { CurrencyEnum, TaxRateTypeEnum } from './enum';

export type ServicePriceItem = z.infer<typeof schemaServicePriceItem>;
export const schemaServicePriceItem = z.object({
  currency: CurrencyEnum,
  unitAmount: z.number(),
  taxRateType: TaxRateTypeEnum,
  taxRateId: z.number().nullable(),
});

export const toItem = (servicePrice: ServicePrice): ServicePriceItem => {
  return {
    currency: servicePrice.currency,
    unitAmount: servicePrice.unitAmount,
    taxRateId: servicePrice.taxRateId,
    taxRateType: servicePrice.taxRateType,
  };
};

export type PublicServicePriceItem = z.infer<
  typeof schemaPublicServicePriceItem
>;
export const schemaPublicServicePriceItem = z.object({
  currency: CurrencyEnum,
  unitAmount: z.number(),
  taxInclusive: TaxInclusiveTextEnum.nullable(),
  taxPercentage: z.number().nullable(),
});

export const toPublicItem = (
  servicePrice: ServicePrice,
  taxRate: TaxRate | null,
): PublicServicePriceItem => {
  let taxInclusive: TaxInclusiveText | null = null;
  if (taxRate) {
    taxInclusive =
      taxRate.taxInclusive === TaxInclusive.Inclusive
        ? TaxInclusiveText.Inclusive
        : TaxInclusiveText.Exclusive;
  }
  return {
    currency: servicePrice.currency,
    unitAmount: servicePrice.unitAmount,
    taxInclusive,
    taxPercentage: taxRate?.percentage ?? null,
  };
};
